import type { AssetsGetShareSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/assets';
import type { SettingsSystemSettingPublicSchemaNullable } from '@iconik-io/iconik-api/src/services/settings';

type EnterpriseSecuritySettings = Pick<
  SettingsSystemSettingPublicSchemaNullable,
  'drm' | 'watermark'
>;

/** The one enabled value the enterprise-security settings take. */
export const isEnterpriseSecuritySettingActive = (
  value: string | null | undefined,
): boolean => value === 'standard';

export function isShareDrmActive(
  share: AssetsGetShareSchemaWithIdNullable | undefined | null,
  systemSettings: EnterpriseSecuritySettings | undefined | null,
): boolean {
  return (
    isEnterpriseSecuritySettingActive(share?.drm) ||
    isEnterpriseSecuritySettingActive(systemSettings?.drm)
  );
}

export function isShareForensicWatermarkActive(
  share: AssetsGetShareSchemaWithIdNullable | undefined | null,
  systemSettings: EnterpriseSecuritySettings | undefined | null,
): boolean {
  return (
    isEnterpriseSecuritySettingActive(share?.watermark) ||
    isEnterpriseSecuritySettingActive(systemSettings?.watermark)
  );
}

export function isShareEnterpriseSecurityActive(
  share: AssetsGetShareSchemaWithIdNullable | undefined | null,
  systemSettings: EnterpriseSecuritySettings | undefined | null,
): boolean {
  return (
    isShareDrmActive(share, systemSettings) ||
    isShareForensicWatermarkActive(share, systemSettings)
  );
}
